// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".schedule-head-grid[data-v-662384c1]{display:grid;font-size:1.2rem;color:var(--text-text-ternary);margin-bottom:1.5rem;padding-top:.75rem;padding-bottom:.75rem;padding-left:1.5rem;padding-right:1.5rem;background-color:var(--highlight-primary);border-radius:4px;grid-template-columns:10.8% 23.8% 25.9% 26.8% auto}", ""]);
// Exports
module.exports = exports;
